/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import { Fragment, ReactElement } from 'react';
import { ImageComponentProp } from '../../types'

type Props = {
  component: ImageComponentProp
  key: number
}

function ImageComponent({ component }: Props): ReactElement {
  return (
    <Fragment>
      <img src={component.image.url} css={imageStyle} className="image_component" />
    </Fragment>
  )
}

const imageStyle = css`
  display: block;
  width: 100%;
`

export default ImageComponent
